import { render, staticRenderFns } from "./GeofenceData.vue?vue&type=template&id=972991e0&scoped=true"
import script from "./GeofenceData.vue?vue&type=script&lang=ts"
export * from "./GeofenceData.vue?vue&type=script&lang=ts"
import style0 from "./GeofenceData.vue?vue&type=style&index=0&id=972991e0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972991e0",
  null
  
)

export default component.exports